import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { QuestionViewEndpoint } from '@core/types/types.endpoint.question';
import { Accordion, AccordionItem } from '@frontend/components/ui/accordion';
import { Button } from '@frontend/components/ui/button';
import { QuestionRelated } from '@frontend/Question/QuestionRelated';
import { SearchInput } from '@frontend/Search/Input/SearchInput';
import { Question } from '@frontend/shared/components/Question/Question';
import { useApi } from '@frontend/shared/hooks/shared.hook.useApi';
import { useSingleSearchParam } from '@frontend/shared/hooks/useSingleSearchParam';

export function QuestionPage() {
  const { id = '' } = useParams<{ id: string }>();
  const [value, onChange] = useState('');
  const [editMode] = useSingleSearchParam('edit');
  const { data, loading, error } = useApi<QuestionViewEndpoint>(
    '/question/view',
    {
      id,
    },
  );
  const navigate = useNavigate();
  const onSearch = (q: string) => {
    if (q) {
      const url = `/questions?q=${q}`;
      return navigate(url);
    }
  };

  return (
    <>
      <SearchInput
        placeholder="Search for other questions…"
        onSearch={onSearch}
        value={value}
        onChange={onChange}
        searchVal=""
      />
      {!data && loading && (
        <h2 className="text-lg font-semibold mt-12">Loading...</h2>
      )}
      {error && (
        <>
          <h2 className="text-lg font-semibold mt-12">
            Error loading question :(
          </h2>
          <div className="flex">
            <Button
              variant="destructive"
              className="mt-4 mr-3"
              onClick={() => {
                window.location.reload();
              }}
            >
              Try again
            </Button>
            <Button asChild className="mt-4">
              <Link to="/questions">Go to Question Base</Link>
            </Button>
          </div>
        </>
      )}
      {data && (
        <>
          <Accordion
            type="single"
            collapsible
            className="mb-4 mt-12"
            defaultValue="question"
            onValueChange={(value) => {
              if (!value) {
                console.log('change', value);
                navigate('/questions');
              }
            }}
          >
            <AccordionItem value="question">
              <Question
                question={data.question}
                isExpanded
                isCloseable
                initialEditMode={!!editMode}
              />
            </AccordionItem>
          </Accordion>
          <QuestionRelated question={data.question} />
          <div className="flex justify-center mt-12">
            <Button asChild>
              <Link to="/questions">Explore Question Base</Link>
            </Button>
          </div>
        </>
      )}
    </>
  );
}
